export enum LinkListType {
  Selected = 'selected',
  Unselected = 'unselected',
}
